export default {
  // 254测试
  // baseUrl: "http://127.0.0.1:8014",
  // baseImgUrl: "http://127.0.0.1:8014",
  // homeImgBaseUrl: "http://127.0.0.1:8014/photo",

  // 237线上测试
  // baseUrl : "http://192.168.1.18:85",
  // baseUrl: "http://222.76.214.237:85",
  // baseImgUrl: "http://222.76.214.237:8089",
  // homeImgBaseUrl: "http://222.76.214.237:8089/photo",

  // 222正式
  // baseUrl: "http://192.168.100.25:8015",
  // baseImgUrl: "http://119.29.107.222:8089",
  // homeImgBaseUrl: "http://119.29.107.222:8089/photo",

  // 222正式https
  // baseUrl : "https://api.qzztcn.com",
  // baseImgUrl : "https://api.qzztcn.com",
  // homeImgBaseUrl : "https://api.qzztcn.com/photo",

  // 222正式https
  // baseUrl : "https://test.zhguser.hefeng.info/webapi",
  // // baseUrl: "http://localhost:8014",
  // baseImgUrl : "https://test.zhguser.hefeng.info/photo",
  // homeImgBaseUrl : "https://test.zhguser.hefeng.info/photo",

  // 生产正式预发布环境
  // baseUrl : "http://test_api.qzztcn.cn",
  // baseImgUrl : "http://test_api.qzztcn.cn",
  // homeImgBaseUrl : "http://test_api.qzztcn.cn/photo",

  // 222正式https
  // baseUrl : "https://api.qzztcn.com",
  // baseImgUrl : "https://api.qzztcn.com",
  // homeImgBaseUrl : "https://api.qzztcn.com/photo",
  // baseApi:'https://api.qzztcn.com/xml',//运单

  baseImgUrl: process.env.BASE_IMG_URL,
  homeImgBaseUrl: process.env.HOME_IMG_BASE_URL,
  baseUrl: process.env.BASE_URL,
  baseApi: process.env.BASE_API,

  // 测试
  // baseUrl: "http://116.62.35.127:7777",
  // baseImgUrl: "http://test.qzztcn.com/files",
  // baseApi: 'http://116.62.35.127/xml',//运单

  // 开发
  // baseImgUrl: "http://127.0.0.1:8000/ufile",
  // baseUrl: "http://127.0.0.1:7777",
  // baseApi: 'http://127.0.0.1:9886/xml',//运单

  // 对{对象}进行一个反义
  handleSense(str) {
    let resss = new RegExp(":", "g")
    let reg = str.replace(resss, ":")
    return reg
  },
  // 时间戳转日期 yyyy/mm/dd
  formatTimeStamp(timestamp) {
    let myDate = new Date(timestamp)
    let year = myDate.getFullYear()
    let month =
      myDate.getMonth() + 1 >= 10
        ? `${myDate.getMonth() + 1}`
        : `0${myDate.getMonth() + 1}`
    let day =
      myDate.getDate() >= 10 ? `${myDate.getDate()}` : `0${myDate.getDate()}`
    return `${year}/${month}/${day}`
  },
  //时间戳转日期 yyyy-mm-dd
  formatTimeStampLine(timestamp) {
    let myDate = new Date(timestamp)
    let year = myDate.getFullYear()
    let month =
      myDate.getMonth() + 1 >= 10
        ? `${myDate.getMonth() + 1}`
        : `0${myDate.getMonth() + 1}`
    let day =
      myDate.getDate() >= 10 ? `${myDate.getDate()}` : `0${myDate.getDate()}`
    return `${year}-${month}-${day}`
  },
  // 日期转时间戳
  formatDate(str) {
    let myDate = new Date(str)
    let timestamp = myDate.getTime()
    return timestamp
  }
}



// WEBPACK FOOTER //
// ./src/config.js